import { render, staticRenderFns } from "./DictCascade.vue?vue&type=template&id=ce062e98&scoped=true"
import script from "./DictCascade.vue?vue&type=script&lang=js"
export * from "./DictCascade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce062e98",
  null
  
)

export default component.exports